var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo",class:{link: _vm.link},style:(_vm.style),attrs:{"src":_vm.asset(_vm.logoPath + '?1', 'img')},on:{"click":_vm.navigate}})
}
var staticRenderFns = []

export { render, staticRenderFns }